import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ZendeskService } from '../zendesk.service';
import { UserInfo } from 'src/app/models/user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private userInfo: UserInfo;

  public static readonly TOKEN_KEY = 'token';

  constructor(private zendeskService: ZendeskService) {}

  async login() {
    const matchAccessToken = window.location.hash.match(/#access_token=(.*?)&/);
    if (matchAccessToken) {
      sessionStorage.setItem(AuthService.TOKEN_KEY, matchAccessToken[1]);
      window.location.hash = '';
    } else {
      const returnTo = new URLSearchParams(window.location.href).get('return_to');
      const redirectTo = returnTo
        ? window.location.origin + '/?zendesk_redirect_uri=' + returnTo + '&return_to=' + returnTo
        : window.location.href;

      const url =
        environment.authConfig.loginUrl +
        '?response_type=token&client_id=' +
        environment.authConfig.clientId +
        '&redirect_uri=' +
        redirectTo;
      window.location.replace(url);
    }
    this.parseToken();
  }

  b64DecodeUnicode(str: string) {
    return decodeURIComponent(
      Array.prototype.map.call(atob(str), c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
    );
  }

  public jwtDecode(tokenStrPayload: string) {
    return JSON.parse(this.b64DecodeUnicode(tokenStrPayload.replace('-', '+').replace('_', '/')));
  }

  private parseToken() {
    const token = sessionStorage.getItem(AuthService.TOKEN_KEY);
    const payload = token?.split('.')[1];

    if (!payload) {
      throw new Error('Cannot parse JWT');
    }
    this.userInfo = this.jwtDecode(payload);
    const zendesk_redirect_uri = window.location.href.match(/zendesk_redirect_uri=(.*)/);
    const return_to = window.location.href.match(/\return_to=(.*)/);
    if (zendesk_redirect_uri && return_to) {
      this.zendeskService.redirectToZendesk(return_to[1], false);
    } else if (zendesk_redirect_uri) {
      this.zendeskService.redirectToZendesk(zendesk_redirect_uri[1], false);
    }
  }

  getUserInfo(): UserInfo {
    return this.userInfo;
  }

  getUserName(): string {
    if (this.userInfo !== null) {
      return this.userInfo.givenName + ' ' + this.userInfo.sn;
    }

    return null;
  }

  logout() {
    sessionStorage.removeItem(AuthService.TOKEN_KEY);
    window.location.href = environment.authConfig.logoutUrl;
  }
}
